class PageShare {
  constructor() {
    this.pageShareList = [];
  }

  add(page) {
    const pageItem = this.pageShareList.find(item => item.path === page.path);
    if (pageItem) {
      const index = this.pageShareList.findIndex(item => item.path === page.path);
      this.pageShareList.splice(index, 1, page);
      return;
    }
    this.pageShareList.push(page);
  }

  remove(path) {
    const pageItem = this.pageShareList.find(item => item.path === path);
    if (pageItem) {
      const index = this.pageShareList.findIndex(item => item.path === path);
      return this.pageShareList.splice(index, 1);
    }
    return false;
  }

  get(path) {
    return this.pageShareList.find(item => item.path === path);
  }
}

export default new PageShare();
